// client/components/Inventar/InventarErstellen.jsx
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../constants/api";
import { showSuccess, showError } from "../../utils/toast.js";
import InventarBlockFormular from "./InventarBlockFormular";
import { useTheme } from "../../context/ThemeContext.jsx";
export default function InventarErstellen() {
  const navigate = useNavigate();
    const [form, setForm] = useState({
    projekttyp: "",
    kategorie: "",
    bezeichnung: "",
    hersteller: "",
    seriennummer: "",
    status: "verfügbar",
    standort_typ: "Lager",
    standort_bez: "",
    notiz: "",
    details: {}
  });
  const [saving, setSaving] = useState(false);
  const mountedRef = useRef(true);
  useEffect(() => {
    document.title = "Inventar anlegen – WireTrack";
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const handleSubmit = async e => {
    e.preventDefault();
    if (saving) return;
    try {
      setSaving(true);
      const {
        data
      } = await api.post("/inventar", {
        projekttyp: form.projekttyp,
        kategorie: form.kategorie,
        bezeichnung: form.bezeichnung,
        hersteller: form.hersteller,
        seriennummer: form.seriennummer,
        status: form.status,
        standort_typ: form.standort_typ,
        standort_bez: form.standort_bez,
        notiz: form.notiz
      });
      const id = data?.data?.id ?? data?.id;
      if (!id) {
        showError("ID fehlt in Serverantwort");
        return;
      }
      await api.post(`/inventar/${id}/details`, form.details || {});
      showSuccess("Inventar erstellt");
      navigate(`/inventar/${id}`);
    } catch (e) {
      console.error("Inventar erstellen:", e);
      showError(e, {
        fallbackKey: "Erstellen fehlgeschlagen"
      });
    } finally {
      if (mountedRef.current) setSaving(false);
    }
  };
  return <div className={`min-h-dvh w-full ${"bg-gradient-to-br from-[#05070c] via-[#0a1020] to-[#0a1a32] text-white"}`}>
      <div className="mx-auto w-full px-3 sm:px-4 py-4 sm:py-6">
        <div className={`mx-auto max-w-screen-sm md:max-w-3xl rounded-2xl shadow-xl ${"glass border border-white/10"}`}>
          <div className="px-4 sm:px-5 py-4 sm:py-5">
            <InventarBlockFormular form={form} setForm={setForm} onSubmit={handleSubmit} onCancel={() => navigate("/inventar")} isSaving={saving} isEdit={false} />
          </div>
        </div>
      </div>
    </div>;
}